// Ошибки интерфейса → /api/client-errors (мобильный аудит, M-71): контроль регресса выпусков
// на телефонах, в Telegram и MAX, где консоль браузера недоступна. Не больше 20 за сессию.
import { clientKind, getToken } from "./api";

let sent = 0;

function report(message: string, source = "") {
  if (sent >= 20 || !message) return;
  sent += 1;
  const token = getToken();
  void fetch("/api/client-errors", {
    method: "POST",
    keepalive: true,
    headers: {
      "Content-Type": "application/json",
      "X-Client": clientKind(),
      "X-Client-Width": window.matchMedia("(max-width: 767.98px)").matches ? "m" : "d",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      message: message.slice(0, 500), source: source.slice(0, 200),
      view: document.documentElement.dataset.view || "", version: document.querySelector('script[type="module"][src*="/assets/index-"]')?.getAttribute("src") || "",
    }),
  }).catch(() => { /* офлайн — не страшно */ });
}

export function installClientErrorReporter() {
  window.addEventListener("error", (e) => report(e.message || String(e.error || ""), `${e.filename || ""}:${e.lineno || 0}`));
  window.addEventListener("unhandledrejection", (e) => report(String((e.reason && (e.reason.message || e.reason)) || "unhandledrejection"), "promise"));
}
